(() => {
  'use strict';
  const host = document.querySelector('[data-cabane-comparison]');
  if (!host || host.dataset.ready) return;
  host.dataset.ready = 'true';
  const strings = JSON.parse(host.querySelector('[data-compare-strings]').textContent);
  const text = (key, values = {}) => Object.entries(values).reduce((s, [k, v]) => s.replaceAll(`{${k}}`, String(v)), strings[key] || key);
  const translate = s => window.CabaneI18n?.text(s) || s;
  const escape = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const root = window.Shopify?.routes?.root || '/';
  const money = n => new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency', currency:window.Shopify?.currency?.active || host.dataset.currency}).format(n / 100);
  const number = n => new Intl.NumberFormat(document.documentElement.lang || 'fr', {maximumFractionDigits:2}).format(n);
  const get = selector => host.querySelector(selector);
  const dialog = get('#lcg-compare-dialog');
  const table = get('#lcg-compare-table');
  const open = get('#lcg-compare-open');
  const storageKey = 'cabane-comparison-v1';
  const selected = new Map();
  let products = new Map(), noticeTimer, scheduled = false, loading = false, revision = 0, profilesPromise;
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
    if (Array.isArray(saved)) for (const item of saved.slice(0, 3)) {
      if (Array.isArray(item) && /^[a-z0-9-]+$/.test(item[0])) selected.set(item[0], String(item[1] || ''));
    }
  } catch {}
  function persist() { try { sessionStorage.setItem(storageKey, JSON.stringify([...selected])); } catch {} }
  function notice(message) {
    get('#lcg-compare-status').textContent = message;
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(() => get('#lcg-compare-status').textContent = '', 4500);
  }
  function cardChoice(input) {
    const label = input.closest('.lcg-simple-compare');
    const card = label.previousElementSibling;
    const link = card?.querySelector('.card > .card__content .card__heading a') || card?.querySelector('a[href*="/products/"]');
    try {
      const url = new URL(link?.href || input.dataset.compareUrl, location.origin);
      const handle = url.pathname.match(/\/products\/([a-z0-9-]+)/)?.[1];
      return handle ? {handle, id:url.searchParams.get('variant') || '', title:link?.textContent.trim() || input.dataset.compareTitle} : null;
    } catch { return null; }
  }
  function synchronize() {
    document.querySelectorAll('[data-cabane-compare-checkbox]').forEach(input => {
      const choice = cardChoice(input);
      input.closest('.lcg-simple-compare').hidden = !choice;
      if (!choice) return;
      input.dataset.compareHandle = choice.handle;
      input.setAttribute('aria-label', text('compare_product', {title:choice.title}));
      input.checked = selected.has(choice.handle);
      input.disabled = selected.size >= 3 && !input.checked;
    });
    get('.lcg-compare-launcher').hidden = selected.size === 0;
    get('#lcg-compare-count').textContent = text(selected.size === 1 ? 'selected_one' : 'selected_many', {count:selected.size});
    get('#lcg-compare-help').hidden = selected.size !== 1;
    open.disabled = selected.size < 2;
    open.setAttribute('aria-label', text('compare_count', {count:selected.size}));
  }
  function loadProfiles() {
    if (window.CabaneTechProfiles) return Promise.resolve();
    if (!profilesPromise) profilesPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = host.dataset.profilesUrl;
      script.onload = resolve;
      script.onerror = () => { script.remove(); profilesPromise = null; reject(new Error('profiles')); };
      document.head.appendChild(script);
    });
    return profilesPromise;
  }
  async function response(url, kind) {
    const r = await fetch(url, {credentials:'same-origin', cache:'no-store', signal:AbortSignal.timeout(15000)});
    if (!r.ok) throw new Error(String(r.status));
    return kind === 'json' ? r.json() : r.text();
  }
  function readPairs(element) {
    if (!element) return [];
    const pairs = [];
    element.querySelectorAll('tr').forEach(row => {
      const cells = [...row.children].filter(c => /^(TD|TH)$/.test(c.tagName));
      if (cells.length === 2) pairs.push({label:cells[0].textContent.trim(), value:cells[1].textContent.trim()});
    });
    element.querySelectorAll('dt').forEach(dt => {
      if (dt.nextElementSibling?.tagName === 'DD') pairs.push({label:dt.textContent.trim(), value:dt.nextElementSibling.textContent.trim()});
    });
    return pairs.filter(p => p.label && p.value);
  }
  async function loadProduct(handle) {
    const url = `${root}products/${encodeURIComponent(handle)}`;
    const [p, html] = await Promise.all([response(`${url}.js`, 'json'), response(url, 'text')]);
    p.options = (p.options || []).map(o => typeof o === 'string' ? o : o.name);
    p.tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map(s => s.trim());
    p.url = url;
    p.variants = (p.variants || []).map(v => ({...v, options:v.options || [v.option1,v.option2,v.option3].filter(Boolean)}));
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const specData = doc.querySelector('cabane-spec-sheet script[type="application/json"]');
    if (specData) {
      const data = JSON.parse(specData.textContent);
      p.technical_sheet = data.technical_sheet;
      p.spec_fields = data.spec_fields;
      if (data.description) p.description = data.description;
    } else {
      const section = doc.querySelector('.pe-tech, .cabane-quick-specs');
      if (section) {
        const variants = section.querySelector('[data-pe-variants]');
        const variantMarkup = variants ? JSON.parse(variants.textContent) : {};
        section.querySelector('[data-pe-variant-specs]')?.remove();
        p.technical_sheet = {groups:[{items:readPairs(section)}], variants:Object.entries(variantMarkup).map(([id, markup]) => ({variant_id:id,items:readPairs(new DOMParser().parseFromString(markup, 'text/html'))}))};
      }
    }
    if (!p.variants.length) throw new Error('variants');
    return p;
  }
  const normalize = s => String(s).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  function productName(p) {
    const pattern = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    let name = (window.CabanePresentation?.title(p) || p.title).split(/\s+[–—]\s+/)[0];
    if (p.vendor) name = name.replace(new RegExp('^'+pattern(p.vendor)+'\\s+', 'i'), '');
    name = name.replace(/\s*[-–—]?\s*trottinette(?:\s+freestyle)?(?:\s+compl[eè]te)?$/i, '').trim();
    const index = p.options.findIndex(option => /couleur|colou?r/i.test(option));
    if (index >= 0) {
      const colors = [...new Set(p.variants.map(v => v.options[index]).filter(Boolean))].sort((a,b) => b.length-a.length);
      for (const color of colors) name = name.replace(new RegExp('\\s+[-–—]?\\s*'+pattern(color)+'$', 'i'), '').trim();
    }
    return name || p.title;
  }
  const primary = [
    ['weight','Poids',['poids','poids total','poids annonce']],
    ['height','Hauteur totale',['hauteur totale','hauteur totale assemblee']],
    ['deck_length','Longueur du deck',['longueur du deck','deck length']],
    ['deck_width','Largeur du deck',['largeur du deck','deck width']],
    ['bar_height','Hauteur du guidon',['hauteur du guidon','hauteur du guidon seul']],
    ['bar_width','Largeur du guidon',['largeur du guidon']],
    ['wheels','Roues',['diametre des roues','diametre roue']],
    ['compression','Compression',['compression','type de compression','type de compression fourche']],
    ['practice','Pratique',['style de ride','pratique conseillee','style ride']],
    ['brake','Frein',['frein','type de frein','matiere du frein']]
  ];
  function facts(p, v) {
    const rows = window.CabaneTechProfiles?.rows(p, v, window.CabaneProductData) || window.CabaneProductData?.rows(p, v) || [];
    const sheet = p.technical_sheet || {};
    const raw = [...(sheet.highlights || []), ...(sheet.groups || []).flatMap(g => g.items || []), ...(sheet.items || [])];
    for (const item of Array.isArray(sheet.variants) ? sheet.variants : []) {
      if (String(item.variant_id ?? item.id) === String(v.id)) raw.push(...(item.items || []), ...(item.groups || []).flatMap(g => g.items || []));
    }
    const values = new Map();
    for (const [key, label, names] of primary) {
      let value = rows.find(row => names.includes(normalize(row.label)))?.value;
      if (!value && ['practice','brake'].includes(key)) value = raw.filter(row => names.includes(normalize(row.label || row.key))).at(-1)?.value;
      if (value != null && value !== '') {
        const match = String(value).match(/^(\d+(?:[.,]\d+)?)\s*(g|kg|mm|cm)$/);
        if (match && key === 'weight') value = `${number(Number(match[1].replace(',','.')) / (match[2] === 'g' ? 1000 : 1))} kg`;
        if (match && key === 'height') value = `${number(Number(match[1].replace(',','.')) / (match[2] === 'mm' ? 10 : 1))} cm`;
        values.set(key, {label, value:String(value)});
      }
    }
    return {rows, values, complete:window.CabaneTechProfiles?.profile(p)?.id === 'scooter-complete'};
  }
  function renderTable() {
    const items = [...selected].map(([handle, id]) => {
      const p = products.get(handle);
      const v = p.variants.find(v => String(v.id) === id) || p.variants.find(v => v.available) || p.variants[0];
      selected.set(handle, String(v.id));
      return {p, v, facts:facts(p, v)};
    });
    persist();
    const definitions = new Map();
    const complete = items.every(item => item.facts.complete);
    if (complete) primary.forEach(([key,label]) => definitions.set(key,label));
    else items.forEach(item => item.facts.rows.forEach(row => definitions.set(normalize(row.label), row.label)));
    const rows = [[text('price'), items.map(item => money(item.v.price))]];
    definitions.forEach((label, key) => rows.push([translate(label), items.map(item => complete ? item.facts.values.get(key)?.value : item.facts.rows.find(row => normalize(row.label) === key)?.value)]));
    table.dataset.count = items.length;
    dialog.dataset.count = items.length;
    table.innerHTML = `<thead><tr><th scope="col"><span class="lcg-spec-title">${escape(text('specifications'))}</span></th>${items.map(({p,v}) => {
      const title = productName(p);
      const image = v.featured_image?.src || p.featured_image || p.images?.[0];
      return `<th scope="col"><div class="lcg-compare-photo">${image ? `<img src="${escape(image)}" alt="${escape(title)}" width="320" height="136">` : ''}</div><p class="lcg-compare-brand">${escape(p.vendor)}</p><h3>${escape(title)}</h3><p class="lcg-compare-price">${money(v.price)}</p><select aria-label="${escape(text('variant_for', {title}))}" data-compare-variant="${escape(p.handle)}">${p.variants.map(variant => `<option value="${variant.id}"${v.id === variant.id ? ' selected' : ''}>${escape(variant.title === 'Default Title' ? text('one_variant') : variant.title)}${variant.available ? '' : ' — '+escape(text('sold_out'))}</option>`).join('')}</select><a href="${escape(p.url)}?variant=${v.id}">${escape(text('view_product'))}</a></th>`;
    }).join('')}</tr></thead><tbody>${rows.map(([label, values]) => `<tr><th scope="row">${escape(label)}</th>${values.map(value => `<td${value == null ? ' class="lcg-value-unknown"' : ''}>${escape(value == null ? text('unknown') : translate(value))}</td>`).join('')}</tr>`).join('')}</tbody>`;
  }
  async function showComparison() {
    if (selected.size < 2 || loading) return;
    loading = true;
    const current = ++revision;
    get('[data-compare-message]').hidden = false;
    get('[data-compare-message-text]').textContent = text('loading');
    get('[data-compare-retry]').hidden = true;
    get('.lcg-compare-scroll').hidden = true;
    if (!dialog.open) dialog.showModal();
    dialog.setAttribute('aria-busy', 'true');
    try {
      const [, loaded] = await Promise.all([loadProfiles(), Promise.all([...selected.keys()].map(loadProduct))]);
      if (current !== revision || !dialog.open) return;
      products = new Map(loaded.map(p => [p.handle, p]));
      renderTable();
      get('[data-compare-message]').hidden = true;
      get('.lcg-compare-scroll').hidden = false;
    } catch {
      if (current !== revision || !dialog.open) return;
      get('[data-compare-message-text]').textContent = text('error');
      get('[data-compare-retry]').hidden = false;
    } finally {
      if (current === revision) { loading = false; dialog.removeAttribute('aria-busy'); }
    }
  }
  document.addEventListener('change', event => {
    const input = event.target;
    if (input.matches('[data-cabane-compare-checkbox]')) {
      const choice = cardChoice(input);
      if (!choice) return;
      if (input.checked) {
        if (selected.size >= 3) { input.checked = false; notice(text('limit')); return; }
        selected.set(choice.handle, choice.id);
      } else selected.delete(choice.handle);
      persist(); synchronize();
    }
    if (host.contains(input) && input.matches('[data-compare-variant]')) {
      selected.set(input.dataset.compareVariant, input.value);
      const handle = input.dataset.compareVariant;
      const top = get('.lcg-compare-scroll').scrollTop;
      renderTable();
      get('.lcg-compare-scroll').scrollTop = top;
      get(`[data-compare-variant="${handle}"]`).focus({preventScroll:true});
    }
  });
  open.addEventListener('click', showComparison);
  get('[data-compare-retry]').addEventListener('click', showComparison);
  get('#lcg-compare-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { revision++; loading = false; dialog.removeAttribute('aria-busy'); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
  get('#lcg-compare-clear').addEventListener('click', () => { selected.clear(); persist(); synchronize(); document.querySelector('[data-cabane-compare-checkbox]')?.focus({preventScroll:true}); });
  new MutationObserver(records => {
    if (!records.some(r => !host.contains(r.target)) || scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; synchronize(); });
  }).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['href']});
  window.addEventListener('pageshow', synchronize);
  synchronize();
})();
